/**
 * Verilen satırları CSV olarak indirir.
 *
 * Excel'in Türkçe yerel ayarında sütunları doğru ayırabilmesi için ayraç `;`,
 * Türkçe karakterlerin bozulmaması için dosyanın başına UTF-8 BOM eklenir.
 *
 * @param {string} filename  Uzantısız dosya adı
 * @param {string[]} headers Başlık satırı
 * @param {Array<Array<string|number|null|undefined>>} rows Veri satırları
 */
export const downloadCsv = (filename, headers, rows) => {
    const escape = (value) => {
        if (value === null || value === undefined) return "";
        const text = String(value);
        // Ayraç, tırnak veya satır sonu içeren hücreler tırnaklanır
        return /[";\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
    };

    const csv = [headers, ...rows]
        .map((row) => row.map(escape).join(";"))
        .join("\r\n");

    const blob = new Blob([`﻿${csv}`], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${filename}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export default downloadCsv;
